import api, { type ResponsePayloadWithData } from '.';
import type { Status } from '../utils/results';
import type { ContentType } from './medialink';

export interface ScoreBase {
  maximum: number;
  achievable: number;
  achieved: number;
  amountOfItems: number;
  status?: Status;
  phases?: {
    id: number;
    name: string;
    stage: number;
    duration: number;
    score: { maximum: number; achievable: number; achieved: number };
  }[];
  isLastPhase?: boolean;
}

// no bueno
export function isMyAssignment(assignment: any): assignment is MyAssignment {
  return 'unachievable' in assignment && 'repeatable' in assignment;
}

export interface MyAssignment {
  id: string;
  name: string;
  from: string;
  to: string;
  moduleId: string;
  moduleName: string;
  superModuleId: string;
  subjectName: string;
  materialId: string;
  materialType: 'user-material' | 'medialink';
  contentType?: ContentType;
  score: ScoreBase & {
    achievedAt?: string;
  };
  sharer: {
    firstName: string;
    lastName: string;
  };
  nodeId: string;
  unachievable: boolean;
  repeatable: boolean;
  hierarchy: {
    id: string;
    title: string;
    prefix?: string;
  }[];
}

export async function getMyAssignments(toggleIANUA?: boolean) {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<MyAssignment[]>>(
    `/studio/user/assignments?studioGroup=${process.env.REACT_APP_P_STUDIO_GROUP}${toggleIANUA ? '&ianua=true' : ''}`,
  );

  return data;
}
